const IframeModalState = (
  currentState = {
    isIframeModalVisible: false
    // icon: 'file-pdf-o'
  },
  action
) => {
  switch (action.type) {
    case 'SHOW_IFRAME':
      return {
        ...currentState,
        isIframeModalVisible: true,
        icon: action.icon,
        title: action.title,
        callback: action.callback,
        hideOpen: action.hideOpen,
        url: action.url
      };
    case 'HIDE_IFRAME':
      return {
        ...currentState,
        isIframeModalVisible: false
      };
    case 'CLOSE_MODAL':
      return {
        ...currentState,
        isIframeModalVisible: false
      };
    default:
      return currentState;
  }
};
export default IframeModalState;
